// extracted by mini-css-extract-plugin
export var active = "_bv-7";
export var container = "_bv-0";
export var evenWidth = "_bv-4";
export var large = "_bv-5";
export var outlet = "_bv-8";
export var slide = "_bv-2";
export var small = "_bv-6";
export var tab = "_bv-3";
export var tabs = "_bv-1";